module.exports = __webpack_public_path__ + "static/media/header.7e2b79b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/WhoWeAre/img/header.jpg
// module id = 380
// module chunks = 0